import StatusCodeError from '../utils/statusCodeError';

const HttpError = (props) => {
    if (typeof window !== 'undefined' && window.location) {
        window.location.reload();
    } else {
        throw new StatusCodeError(props.statusCode, props.message);
    }
};

export default HttpError;
